import { gql } from '@/__generated__';
import BlockHeader from '@/components/BlockHeader';
import { createBlock } from '@/lib/parsers/blocks';
import { excludeEmptyTypedElements } from '@liquorice/utils';
import { Grid } from '@mui/material';
import { BlockContainer } from '../..';
import { EntryExternalCardBlock } from '../ExternalCardBlock/ExternalCardBlock.Entry';
import { SimpleCardBlock } from '../SimpleCardBlock';

export const ENTRY_CARDS_BLOCK_FRAGMENT = gql(`
  fragment entryCardsBlock on blocks_entryCards_BlockType {
    heading
    simpleCardMultiple {
      ...simpleCardBlock
      ...externalCardBlock
    }
  }
`);

export const EntryCardsBlock = createBlock(ENTRY_CARDS_BLOCK_FRAGMENT, ({ data, meta }) => {
  const { heading } = data;
  const items = excludeEmptyTypedElements(data.simpleCardMultiple);

  return (
    <BlockContainer meta={meta} marginY customAnchor={heading}>
      <BlockHeader
        maxWidth="none"
        alignItems="center"
        heading={heading}
        HeadingProps={{ cx: { mB: 'xl' }, autoMargin: false, uppercase: true }}
      />
      <Grid container justifyContent="center" spacing={2}>
        {items?.map((item, index) => (
          <Grid item xs={12} md={6} lg={4} key={index}>
            {item?.__typename === 'externalCard_Entry' ? (
              <EntryExternalCardBlock key={index} data={item} />
            ) : (
              <SimpleCardBlock key={index} data={item} />
            )}
          </Grid>
        ))}
      </Grid>
    </BlockContainer>
  );
});

export default EntryCardsBlock;
